// Lib
import React from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

// Utils
import { getCanvasLocationFromClientOffset } from '../../canvas/utils/canvasPositionUtils';
import { getCanvasOriginCoordinates } from '../../../common/elements/utils/elementPropertyUtils';

// Hooks
import useContextMenuGestureRecognizer from '../touchGestures/useContextMenuGestureRecognizer';
import { useAndroidPreventContextMenuEvent } from '../touchGestures/useAndroidPreventContextMenuEvent';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// Components
import ContextMenuManager from './ContextMenuManager';

// Types
import { BoardSections } from '../../../common/boards/boardConstants';
import { ImMNElement } from '../../../common/elements/elementModelTypes';

// Styles
import './CanvasContextMenuManager.scss';

// TODO: Move to ContextMenuManager once it has been converted to TS
type ContextMenuManagerProps = {
    dispatchGetCurrentFocus: () => string;
    zoomScale: number;
    zoomTranslationPx: { x: number; y: number };
};

type CanvasContextMenuManagerProps = {
    children: React.ReactNode;
    gridSize: number;
    currentBoardId: string;
    currentBoard: ImMNElement;
    blockTemplateInteraction: boolean;
    rootBoardId: string;
    isEditable: boolean;
    workspaceRef: React.RefObject<HTMLDivElement>;
};

const getMenuLocation = (event: any, props: CanvasContextMenuManagerProps & ContextMenuManagerProps) => {
    const { gridSize, currentBoardId, currentBoard, dispatchGetCurrentFocus, zoomScale, zoomTranslationPx } = props;

    const target = event.detail.target;
    const domNode = ReactDOM.findDOMNode(target);
    if (!domNode) return;

    const canvasViewportDomElement = (domNode as HTMLElement).querySelector('.CanvasViewport');
    if (!canvasViewportDomElement) return;

    const canvasOrigin = getCanvasOriginCoordinates(currentBoard);

    const { location } = getCanvasLocationFromClientOffset(
        canvasViewportDomElement as HTMLElement,
        event.detail.position,
        gridSize,
        currentBoardId,
        canvasOrigin,
        zoomScale,
        zoomTranslationPx,
    );

    location.section = dispatchGetCurrentFocus() as BoardSections;

    return location;
};

const CanvasContextMenuManager = (props: CanvasContextMenuManagerProps) => {
    const { workspaceRef } = props;

    const platformDetails = useSelector(getPlatformDetailsSelector);

    useAndroidPreventContextMenuEvent(workspaceRef);

    if (platformDetails.features.isTouch) {
        useContextMenuGestureRecognizer(props.workspaceRef);
    }

    return (
        <ContextMenuManager
            {...props}
            className="CanvasContextMenuManager"
            getLocation={getMenuLocation}
            menuId="canvas-menu"
        />
    );
};

export default CanvasContextMenuManager;
